import { procurementAPI } from "../../axios";

export const actions = {

    //RfqSupplier
    GetSingleRfqSupplierByRFQ(context, data){
        return procurementAPI.get(`RfqSupplier/Rfq/${data}`);
    },
    GetSingleRfqSupplier(context, data){
        return procurementAPI.get(`RfqSupplier/${data}`);
    },
    UpdateRfqSupplier(context, data){
        return procurementAPI.put(`RfqSupplier/${data.id}`, data.RfqItemDetails);
    },
    UpdateReturnedDate(context, data){
        return procurementAPI.put(`RfqSupplier/Update/${data.id}?rfqReturnDate=${data.rfqDate}`);
    },
    DeleteRfqSupplier(context, data){
        return procurementAPI.delete(`RfqSupplier/${data}`);
    },
    CreateRfqSupplier(context, data){
        return procurementAPI.post(`RfqSupplier/Add`, data);
    },
    RfqSupplierSubmission(context, data){
        return procurementAPI.put(`RfqSupplier/Submission/Status/${data.id}/${data.status}`);
    },
    RfqSupplierCOD(context, data){
        return procurementAPI.put(`RfqSupplier/COD/Status/${data.id}/${data.status}`);
    },
    AddInvitedSupplier(context, data){
        return procurementAPI.post(`RfqInvitedSupplier/Add`, data);
    },
    GetInvitedSupplier(context, data){
        return procurementAPI.get(`RfqInvitedSupplier/Invited/${data}`);
    },
    RemoveInvitedSupplier(context, data){
        return procurementAPI.delete(`RfqInvitedSupplier/Remove/${data}`);
    }
}